import { Component } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  constructor(private router: Router, private location: Location) {}

  goHome() {
    this.router.navigateByUrl('/');
  }

  goBack() {
    // If there's no history, fallback to home
    if (window.history.length > 1) this.location.back();
    else this.goHome();
  }

}
